import React from "react";
import { getValue } from "../lib/helper";
import { clsx } from "clsx";

type Props = {
  inputRef?: any,
  label?: string,
  value?: any,
  defaultValue?: any,
  id?: string,
  name?: string,
  inline?: boolean,
  rounded?: boolean,
  required?: boolean,
  placeholder?: string,
  onChange?: (e: any) => void,
  onKeyPress?: (e: any) => void,
  error?: boolean,
  errorString?: string,
  disabled?: boolean,
  className?: string,
  inputClass?: string,
};

const Textarea = React.forwardRef<HTMLTextAreaElement, Props>(({
  inputRef,
  label,
  value,
  defaultValue,
  id,
  name,
  placeholder,
  onChange,
  onKeyPress,
  errorString,
  inline,
  rounded,
  required,
  error,
  disabled,
  className,
  inputClass,
}: Props, ref) => (
  <div className={clsx({ "form-element": true, inline })} ref={inputRef}>
    {label && <label htmlFor={id}>{label}</label>}
    <div
      className={clsx({
        "form-control-container": true,
        [`${className ? className : ""}`]: className,
      })}
    >
      <textarea
        className={clsx({
          "form-control": true,
          rounded: rounded,
          error: error,
          disabled: disabled,
          [`${inputClass ? inputClass : ""}`]: inputClass,
        })}
        onChange={onChange}
        onKeyPress={onKeyPress}
        value={getValue(value)}
        defaultValue={defaultValue}
        name={name}
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        ref={ref}
      />

      {error && errorString && <span className="input-error">{errorString}</span>}
    </div>
  </div>
));

export default Textarea;
